export default {
  common: {
    brand: 'USFans Spreadsheet',
    nav: {
      home: 'Strona główna',
      categories: 'Kategorie',
      guides: 'Poradniki',
      shoppingGuide: 'Poradnik zakupowy',
      safety: 'Bezpieczeństwo',
      faq: 'FAQ',
    },
    cta: {
      spreadsheet: 'usfans spreadsheet',
      buyNow: 'buy it now',
      explore: 'Przeglądaj USFans Spreadsheet',
      browseDirectory: 'Przeglądaj katalog',
    },
    search: {
      placeholder: 'Szukaj USFans Spreadsheet, produktów, kategorii lub poradników…',
    },
    language: 'Język',
    footer: {
      tagline: 'Niezależne centrum zasobów, które pomaga znajdować, porównywać i przeglądać zasoby USFans Spreadsheet — uporządkowane, aktualne i wielojęzyczne.',
      resources: 'Zasoby',
      resourcesGuides: 'Poradniki',
      resourcesCategories: 'Kategorie',
      resourcesSafety: 'Poradnik bezpieczeństwa',
      resourcesFaq: 'FAQ',
      company: 'Firma',
      about: 'O nas',
      editorialPolicy: 'Polityka redakcyjna',
      contact: 'Kontakt',
      legal: 'Informacje prawne',
      privacy: 'Polityka prywatności',
      terms: 'Regulamin',
      disclaimer: 'Zastrzeżenia',
      rights: 'Wszelkie prawa zastrzeżone.',
    },
    languages: {
      en: 'English',
      pl: 'Polski',
      es: 'Español',
      fr: 'Français',
    },
  },
};